import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Winter Park, FL?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a Winter Park area post office or Orange County clerk can take 2–6 months, especially during busy travel seasons.",
  },
  {
    q: "Where is the closest passport agency to Winter Park?",
    a: "The closest regional passport agency to Winter Park is the Miami Passport Agency, located at 1501 Biscayne Blvd, Suite 210, Miami, FL 33132 — about 235 miles south on the Florida Turnpike or I-95. Regional agencies require appointments and are primarily reserved for life-or-death emergencies. Fast Passport Center can often provide a faster, more convenient option using approved courier submission — no drive to Miami required.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Winter Park travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Winter Park, but that's the point: you don't need one. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the Winter Park or greater Orlando area.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order.",
  },
  {
    q: "Can I get an expedited passport if I've never had one before?",
    a: "Yes, but first-time applicants typically require an in-person acceptance clerk visit before documents can be submitted for expedited processing. We guide you through exactly what to do and where to go in the Winter Park area, including the Winter Park Post Office and Orange County Clerk of Court.",
  },
  {
    q: "How long does a passport take through the post office in Winter Park?",
    a: "Standard government processing through a Winter Park area acceptance facility (post office or clerk of court) can take 2–6 months depending on government workload and the time of year. If your travel date is sooner than that, using an approved passport courier like Fast Passport Center is the safer option.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
  {
    q: "What if I need a child passport in Winter Park?",
    a: "Child passports (for minors 15 and under) require parental participation and an in-person acceptance step — both parents typically must consent. We provide clear instructions and a checklist so you know exactly what to do at a Winter Park area acceptance facility. Expedited processing options are available after the acceptance step.",
  },
  {
    q: "Can I get a passport if mine is lost or stolen?",
    a: "Yes. Lost or stolen passport replacements often require additional forms (including Form DS-64 to report the lost passport). We guide you through exactly what's needed and help ensure the correct process is followed to avoid delays.",
  },
  {
    q: "Do cruise passengers from Winter Park need passports?",
    a: "Yes. While some cruise lines allow closed-loop cruises (departing and returning to the same U.S. port) with a birth certificate and government-issued ID, most international cruises and all cruises with foreign port stops require valid passports for every passenger, including children. Additionally, if you need emergency medical evacuation in a foreign port, a passport is required for re-entry. We strongly recommend all cruise passengers carry valid passports.",
  },
  {
    q: "How does the six-month passport validity rule affect Winter Park travelers?",
    a: "Many Winter Park travelers head to Europe for study abroad programs, the Caribbean for family cruises, and Latin America for academic field studies and eco-tourism. Most of these destinations require your passport to be valid for at least six months beyond your planned return date. Airlines often enforce this rule at check-in even more strictly than immigration officials at your destination. If your passport expires within six months of your return date, you may be denied boarding — even if your destination technically allows shorter validity.",
  },
];

export default function WinterParkFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Winter Park and greater Orlando travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}